import { FC, useState } from "react";
import "./Input.module.css";
import InputMask from "react-input-mask";
import "./style.react.scss";
import IntlCurrencyInput from 'react-intl-currency-input'
import { isNumber } from "../../functions/price_functions";
import styles from "./Input.module.css";
type Props = {
	label?: string;
	getFieldProps?: any;
	inputAttr?: any;
	checked?: boolean;
	disabled?: boolean;
	checkSwift?: boolean;
	options?: any;
	value?: any;
	change?: any;
	placeholder?: string;
	maxLength?: string;
	minLength?: string;
	minNumber?: number;
	rows?: number;
	maxCaracteres?: number;
	currency?: string;
	locale?: string;
	isSecure?: boolean;
	autoComplete?: string;
	name?: string;
	defaultValue?: string;
	focus?: boolean;
	smalltext?: string;
	acceptFile?: string;
	blur?: (value: string) => void;
	search?: boolean;
	textCenter?: boolean;
	backgroundColor?: string
	id?: string;
};

const Input: FC<Props> = (props) => {
	const {
		disabled,
		label,
		getFieldProps,
		inputAttr,
		checked,
		options,
		value,
		change,
		placeholder,
		minLength,
		maxLength,
		checkSwift,
		minNumber,
		rows,
		maxCaracteres,
		currency,
		locale,
		isSecure = true,
		autoComplete,
		name,
		defaultValue,
		focus,
		smalltext,
		acceptFile,
		blur,
		search,
		textCenter,
		backgroundColor,
		id
	} = props;

	const [hiddenPassword, setHiddenPassword] = useState<boolean>(isSecure);

	switch (inputAttr.type) {
		case "radio":
			return (
				<div className="mt-6">
					<label className="d-flex align-items-center">
						<input
							{...getFieldProps}
							{...inputAttr}
							value={value}
							defaultChecked={checked}
						/>
						<span className="btn btn-sm btn-color-muted btn-active btn-active-primary ps-2 pe-4 py-0">
							{label}
						</span>
					</label>
				</div>
			);
		case "checkbox":
			return (
				<div className="mt-4">
					<label
						className={`form-check ${checkSwift &&
							"form-switch form-check-custom form-check-solid"
							}`}
					>
						<input
							{...getFieldProps}
							{...inputAttr}
							className="form-check-input"
							value={value}
							defaultChecked={checked}
							disabled={disabled}
							onChange={(event) => change(event.target.checked)}
						/>
						<span
							className={`form-check-label ${checkSwift
								? "fw-normal ms-5 text-gray-800"
								: "fw-normal text-gray-800 ms-1"
								}`}
						>
							{label}
						</span>
					</label>
				</div>
			);
		case 'checkbox_modal_vendedor':
			return (
				<div className={styles.input_div_container}>
					<label

						className={styles.input_label_checkbox}>
						<input
							{...getFieldProps}
							{...inputAttr}
							type="checkbox"
							checked={checked}
							value={value}
							id={id}
							defaultChecked={checked}
							disabled={disabled}
							onChange={(event) => change(event.target.checked)}
							onBlur={(event: any) => blur && blur(event.target.value)}

						/>
						<span
							className={`form-check-label ${checkSwift
								? "fw-normal ms-5 text-gray-800"
								: "fw-normal text-gray-800 ms-1"
								}`}
						>
							{label}
						</span>
					</label>
				</div>
			);
		case "search":
			return (
				<div className="d-flex align-items-center border border-hover-primary px-3 rounded mt-6">
					<i className="fas fa-search"></i>
					<input
						className="border-0 w-100 form-control"
						type="text"
						placeholder={placeholder}
						value={value}
						onBlur={(event: any) =>
							blur && blur(event.target.value)
						}
						onChange={(event) => change(event.target.value)}
					/>
				</div>
			);
		case "date":
			return (
				<div className={`mt-6 `}>
					{label && (
						<label className="form-label fw-normal">{label}</label>
					)}
					<div className="d-flex align-items-center border border-hover-primary px-3 rounded">
						<input
							className="border-0 w-100 form-control fw-normal"
							type="date"
							placeholder={placeholder}
							value={value}
							onChange={(event) => change(event.target.value)}
							min={minLength}
							max={maxLength}
						/>
					</div>
				</div>
			);

		case "date_modal_vendedor":
			return (
				<div className={styles.input_div_container}>
					{label && (
						<label className={styles.input_label}>
							{label} <small>{smalltext}</small>
						</label>
					)}
					<div className={styles.input_container_input_password}>
						<input
							className={styles.input_input_component + " " + (backgroundColor ? `bg-[${backgroundColor}]` : "")}
							type="date"
							placeholder={placeholder}
							style={{
								backgroundColor: backgroundColor ?? '',
								textAlign: textCenter ? "center" : "left",
								height: `38px`,
							}}

							value={value}
							onChange={(event) => change(event.target.value)}
							min={minLength}
							max={maxLength}
							onBlur={(event: any) => blur && blur(event.target.value)}
							id={`date-input-${name || 'default'}`}
						/>
						<i
							className="fa fa-calendar cursor-pointer"
							onClick={() => (document.getElementById(`date-input-${name || 'default'}`) as HTMLInputElement)?.showPicker()}
							style={{
								position: 'relative',
								right: '20px',
								top: '6px',
								transform: 'translateY(-50%)',
								color: '#6c757d',
								pointerEvents: 'all'
							}}
						></i>

					</div>
				</div>
			);
		case "email":
			return (
				<div className="mt-6">
					{label && (
						<label className="form-label fw-normal">{label}</label>
					)}
					<div className="d-flex align-items-center border border-hover-primary rounded">
						<input
							className="border-0 w-100 form-control fw-normal"
							type="email"
							placeholder={placeholder}
							value={value}
							onChange={(event) => change(event.target.value)}
						/>
					</div>
				</div>
			);
		case "number":
			return (
				<div className="mt-6">
					{label && (
						<label className="form-label fw-normal">{label}</label>
					)}
					<div className="d-flex align-items-center border border-hover-primary rounded">
						<input
							className={
								textCenter
									? "border-0 w-100 form-control fw-normal text-center"
									: "border-0 w-100 form-control fw-normal"
							}
							type="number"
							placeholder={placeholder}
							value={value}
							onChange={(event) => change(event.target.value)}
							min={minNumber}
						/>
					</div>
				</div>
			);
		case "tel":
			return (
				<div className="mt-6">
					{label && (
						<label className="form-label fw-normal">{label}</label>
					)}
					<div className="d-flex flex-grow-1 align-items-center border border-hover-primary rounded">
						<InputMask
							className="border-0 w-100 form-control fw-normal"
							mask="(99) 99999-9999"
							placeholder={placeholder}
							value={value}
							onChange={(event: any) =>
								change(event.target.value)
							}
						/>
					</div>
				</div>
			);

		case "time":
			return (
				<div>
					{label && (
						<label className="form-label fw-normal">{label}</label>
					)}
					<div className="d-flex align-items-center border border-hover-primary px-3 rounded">
						<InputMask
							className="border-0 w-100 form-control fw-normal text-center"
							mask="99:99:99"
							placeholder={placeholder}
							value={value}
							onChange={(event: any) =>
								change(event.target.value)
							}
							onBlur={(event: any) =>
								blur && blur(event.target.value)
							}
						/>
					</div>
				</div>
			);
		case "cnpj":
			return (
				<div className="mt-6">
					{label && (
						<label className="form-label fw-normal">{label}</label>
					)}
					<div className="d-flex align-items-center border border-hover-primary rounded">
						<InputMask
							className="border-0 w-100 form-control fw-normal"
							mask="99.999.999/9999-99"
							placeholder={placeholder}
							value={value}
							onChange={(event: any) =>
								change(event.target.value)
							}
							disabled={disabled}
						/>
					</div>
				</div>
			);
		case "cep":
			return (
				<div className="mt-6">
					{label && (
						<label className="form-label fw-normal">{label}</label>
					)}
					<div className="d-flex align-items-center border border-hover-primary rounded">
						<InputMask
							className="border-0 w-100 form-control fw-normal"
							mask="99999-999"
							placeholder={placeholder}
							value={value}
							onChange={(event: any) =>
								change(event.target.value)
							}
							onBlur={(event: any) =>
								blur && blur(event.target.value)
							}
						/>
					</div>
				</div>
			);
		case "cpf":
			return (
				<div className="mt-6">
					{label && (
						<label className="form-label fw-normal">{label}</label>
					)}
					<div className="d-flex align-items-center border border-hover-primary rounded">
						<InputMask
							className="border-0 w-100 form-control fw-normal"
							mask="999.999.999-99"
							placeholder={placeholder}
							value={value}
							onChange={(event: any) =>
								change(event.target.value)
							}
							onBlur={(event: any) =>
								blur && blur(event.target.value)
							}
						/>
					</div>
				</div>
			);
		case "color":
			return (
				<div className="mt-6">
					{label && (
						<label className="form-label fw-normal">{label}</label>
					)}
					<div className="d-flex min-w-150px align-items-center border border-hover-primary rounded">
						<input
							className="border-0 w-100 form-control fw-normal"
							type="color"
							value={value}
							onChange={(event) => change(event.target.value)}
						/>
					</div>
				</div>
			);
		case "textarea":
			return (
				<div className="mt-6">
					{label && (
						<label className="form-label fw-normal">{label}</label>
					)}
					<div className="d-flex min-w-150px align-items-center border border-hover-primary rounded">
						<textarea
							className="border-0 w-100 form-control fw-normal"
							value={value}
							placeholder={placeholder}
							maxLength={maxCaracteres}
							rows={rows}
							onChange={(event) => change(event.target.value)}
						></textarea>
					</div>
				</div>
			);
		case "password":
			return (
				<div className="mt-6 flex-grow-1">
					{label && (
						<label className="form-label fw-normal">{label}</label>
					)}
					<div className="d-flex align-items-center border border-hover-primary rounded">
						<input
							className="border-0 w-100 form-control fw-normal"
							type={hiddenPassword ? "password" : "default"}
							placeholder={placeholder}
							value={value}
							onChange={(event) => change(event.target.value)}
							disabled={disabled}
							autoComplete={autoComplete}
						/>
						{hiddenPassword ? (
							<i
								style={{
									color: "#ccc",
									fontSize: 20,
									paddingRight: 12,
								}}
								className="fa fa-solid fa-eye cursor-pointer text-hover-primary"
								onClick={() =>
									setHiddenPassword(!hiddenPassword)
								}
							></i>
						) : (
							<i
								style={{
									color: "#ccc",
									fontSize: 20,
									paddingRight: 10,
								}}
								className="fa fa-solid fa-eye-slash cursor-pointer text-hover-primary"
								onClick={() =>
									setHiddenPassword(!hiddenPassword)
								}
							></i>
						)}
					</div>
				</div>
			);
		case "file":
			return (
				<div>
					<input
						type="file"
						name="file"
						accept={acceptFile ? acceptFile : ""}
						onChange={(event) => change(event)}
						value={value}
					/>
				</div>
			);

		case "money":
			return (
				<div>
					<IntlCurrencyInput
						className="money"
						style={{
							color: '#606060',
							fontSize: 20,
							'border-width': 1,
							'border-radius': 4,
							textAlign: 'center',
							height: 35,
							"margin-left": 15,
							"background-color": backgroundColor ? backgroundColor : "#F5F5F5"
						}}
						currency={currency}
						config={{
							locale: locale,
							formats: {
								number: {
									BRL: {
										style: 'currency',
										currency: currency,
										minimumFractionDigits: 2,
										maximumFractionDigits: 2,
									},
								},
							},
						}}
						disabled={disabled ? disabled : false}
						onChange={(event: any, value: number, maskedValue: string) => change(value)}
						value={value}
						onBlur={(event: any) => blur && blur(event.target.value)}
					/>
				</div>
			)

		case 'percent':
			return (
				<div className="mt-4">
					{label && (
						<label className="form-label fw-normal">{label}</label>
					)}
					<div className="" style={{
						color: '#1C1C29',
						fontSize: 13,
						width: '85px',
						fontWeight: 700,
						border: '0px',
						textAlign: 'end',
						display: 'flex',
						alignItems: 'center',
					}}>

						<input
							style={{
								color: '#1C1C29',
								fontSize: 13,
								width: '85px',
								fontWeight: 700,
								border: '0x',
								borderTop: '1px',
								borderLeft: '1px',
								borderRight: '1px',
								textAlign: 'center',
								display: 'flex',
								alignItems: 'center',
							}}
							placeholder={placeholder}
							value={value}
							onChange={(event: any) => {
								const floadValue = parseFloat(event.target.value)
								isNumber(floadValue) ? change(floadValue) : change(0)
							}
							}
							onBlur={(event: any) =>
								blur && blur(event.target.value)
							}
						/>
						<span style={
							{
								position: 'relative',
								right: '2px',
							}
						}>
							%
						</span>
					</div>
				</div>
			)
		case 'money_Discount':
			return (
				<div>
					<IntlCurrencyInput
						className="money"
						style={{
							color: '#1C1C29',
							fontSize: 13,
							width: '85px',
							fontWeight: 700,
							border: '0x',
							borderTop: '1px',
							borderLeft: '1px',
							borderRight: '1px',
							textAlign: 'center',
							display: 'flex',
							alignItems: 'center',
						}}
						currency={currency}
						config={{
							locale: locale,
							formats: {
								number: {
									BRL: {
										style: 'currency',
										currency: currency,
										minimumFractionDigits: 2,
										maximumFractionDigits: 2,
									},
								},
							},
						}}
						onChange={(event: any, value: number, maskedValue: string) => change(value)}
						value={value}
						onBlur={(event: any) => blur && blur(event.target.value)}
					/>
				</div>
			)
		default:
			return (
				<div className="mt-6 flex-grow-1">
					{label && (
						<label className="form-label fw-normal">
							{label} <small>{smalltext}</small>
						</label>
					)}
					<div className="d-flex align-items-center border border-hover-primary rounded">
						<input
							className={
								textCenter
									? "border-0 w-100 form-control fw-normal text-center"
									: "border-0 w-100 form-control fw-normal"
							}
							type="text"
							placeholder={placeholder}
							value={value}
							onChange={(event) => change(event.target.value)}
							disabled={disabled}
							name={name}
							defaultValue={defaultValue}
							autoFocus={focus}
						/>
					</div>
				</div>
			);
	}
};

export { Input };
